(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-video-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-video-showcase')) {
    class ProductVideoShowcase extends HTMLElement {
      constructor() {
        super();
        this.updateNavigation = this.updateNavigation.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.viewport = this.querySelector('.product-video-showcase__viewport');
        this.previousButton = this.querySelector('.product-video-showcase__nav--previous');
        this.nextButton = this.querySelector('.product-video-showcase__nav--next');
        this.dialog = this.querySelector('.product-video-showcase__dialog');
        this.playerHost = this.querySelector('[data-product-video-player]');
        this.closeButton = this.querySelector('[data-product-video-close]');
        this.triggers = Array.from(this.querySelectorAll('.product-video-showcase__card'));

        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => this.openVideo(trigger));
        });

        this.querySelectorAll('[data-youtube-id]').forEach((image) => {
          const videoId = image.dataset.youtubeId;
          if (!videoId) return;

          image.addEventListener('error', () => {
            if (image.dataset.fallbackApplied === 'true') return;
            image.dataset.fallbackApplied = 'true';
            image.src = `https://i.ytimg.com/vi/${encodeURIComponent(videoId)}/hqdefault.jpg`;
          });

          image.src = `https://i.ytimg.com/vi/${encodeURIComponent(videoId)}/maxresdefault.jpg`;
        });

        this.previousButton.addEventListener('click', () => this.scrollByCard(-1));
        this.nextButton.addEventListener('click', () => this.scrollByCard(1));
        this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
        this.closeButton.addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.clearPlayer());
        window.addEventListener('resize', this.updateNavigation, { passive: true });
        requestAnimationFrame(this.updateNavigation);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.updateNavigation);
        if (this.dialog && this.dialog.open) this.dialog.close();
        this.clearPlayer();
      }

      openVideo(trigger) {
        const item = trigger.closest('.product-video-showcase__item');
        const template = item ? item.querySelector('[data-product-video-template]') : null;
        if (!template || !this.dialog || !this.playerHost) return;

        this.openedBy = trigger;
        this.playerHost.replaceChildren(template.content.cloneNode(true));
        this.dialog.setAttribute('aria-label', trigger.dataset.videoTitle || '');
        this.dialog.showModal();
        document.body.classList.add('overflow-hidden');

        if (trigger.dataset.videoProvider === 'instagram') {
          this.watchInstagramEmbed();
          this.processInstagramEmbed();
        }

        const video = this.playerHost.querySelector('video');
        if (video) video.play().catch(() => {});
      }

      clearPlayer() {
        if (this.instagramObserver) {
          this.instagramObserver.disconnect();
          this.instagramObserver = null;
        }
        if (this.instagramReadyTimer) {
          window.clearTimeout(this.instagramReadyTimer);
          this.instagramReadyTimer = null;
        }
        this.setPlayerLoading(false);
        if (this.playerHost) this.playerHost.replaceChildren();
        document.body.classList.remove('overflow-hidden');
        if (this.openedBy) this.openedBy.focus();
        this.openedBy = null;
      }

      setPlayerLoading(isLoading) {
        if (!this.playerHost) return;
        this.playerHost.classList.toggle('is-loading', isLoading);
        if (isLoading) {
          this.playerHost.setAttribute('aria-busy', 'true');
        } else {
          this.playerHost.removeAttribute('aria-busy');
        }
      }

      watchInstagramEmbed() {
        this.setPlayerLoading(true);

        const markReady = () => {
          this.setPlayerLoading(false);
          if (this.instagramObserver) {
            this.instagramObserver.disconnect();
            this.instagramObserver = null;
          }
          if (this.instagramReadyTimer) {
            window.clearTimeout(this.instagramReadyTimer);
            this.instagramReadyTimer = null;
          }
        };

        const bindIframe = () => {
          const iframe = this.playerHost ? this.playerHost.querySelector('iframe') : null;
          if (!iframe || iframe.dataset.productVideoLoadBound === 'true') return;
          iframe.dataset.productVideoLoadBound = 'true';
          iframe.addEventListener('load', markReady, { once: true });
        };

        this.instagramObserver = new MutationObserver(bindIframe);
        this.instagramObserver.observe(this.playerHost, { childList: true, subtree: true });
        bindIframe();

        // Reveal Instagram's fallback content if its embed script is blocked or unavailable.
        this.instagramReadyTimer = window.setTimeout(markReady, 10000);
      }

      processInstagramEmbed() {
        const processEmbeds = () => {
          if (window.instgrm && window.instgrm.Embeds) window.instgrm.Embeds.process();
        };

        if (window.instgrm && window.instgrm.Embeds) {
          processEmbeds();
          return;
        }

        let script = document.querySelector('script[data-product-video-instagram]');
        if (!script) {
          script = document.createElement('script');
          script.src = 'https://www.instagram.com/embed.js';
          script.async = true;
          script.dataset.productVideoInstagram = 'true';
          document.body.appendChild(script);
        }

        script.addEventListener('load', processEmbeds, { once: true });
      }

      scrollByCard(direction) {
        const item = this.querySelector('.product-video-showcase__item');
        if (!item) return;
        const track = this.querySelector('.product-video-showcase__track');
        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        this.viewport.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }

      handleScroll() {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updateNavigation();
        });
      }

      updateNavigation() {
        if (!this.viewport || !this.previousButton || !this.nextButton) return;
        const firstMedia = this.querySelector('.product-video-showcase__media');
        if (firstMedia) this.style.setProperty('--product-video-nav-top', `${firstMedia.offsetHeight / 2}px`);
        const maximumScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const hasOverflow = maximumScroll > 2;
        this.previousButton.hidden = !hasOverflow;
        this.nextButton.hidden = !hasOverflow;
        this.previousButton.disabled = this.viewport.scrollLeft <= 2;
        this.nextButton.disabled = this.viewport.scrollLeft >= maximumScroll - 2;
      }
    }

    customElements.define('product-video-showcase', ProductVideoShowcase);
  }

  } catch(e) { console.error(e); }
})();
})();
